<p class="paragraph">
  {{loaderMessage}}
</p>
@if (fileType == 'application/pdf' && showPDFPreview == true) {
  <pdf-viewer
    id="pdf-viewer"
    [src]="pdfSrc"
    [rotation]="0"
    [original-size]="false"
    [show-all]="true"
    [fit-to-page]="false"
    [zoom]="1"
    [zoom-scale]="'page-width'"
    [stick-to-page]="false"
    [render-text]="true"
    [external-link-target]="'blank'"
    [autoresize]="true"
    [show-borders]="false"
    (after-load-complete)="afterLoadComplete($event)"
    class="viewer-window"
  ></pdf-viewer>
}